module.exports = __webpack_public_path__ + "img/two_1.fe61decd.png";